import { ref, watch } from "vue";
const requests = ref(0);
/** Ask the current page to open its keyboard shortcuts (the sidebar's Help fan does this). */
export function requestShortcutsHelp() {
    requests.value += 1;
}
/** Open this page's shortcuts whenever the sidebar asks; stops with the page's component. */
export function onShortcutsHelpRequest(open) {
    watch(requests, open);
}
/** True while a menu or dialog is open or focused, so its keys (Escape above all) never reach the page's shortcuts. */
export function overlayOpen() {
    if (document.querySelector(".v-overlay--active:not(.v-snackbar):not(.v-tooltip)"))
        return true;
    return Boolean(document.activeElement?.closest(".v-overlay__content:not(.v-snackbar__wrapper)"));
}
